/** Parsuje place_tags (AWSJSON) — i dvojitě serializovaný JSON string. */
export function parsePlaceTags(raw: unknown): string[] {
  let current: unknown = raw;

  for (let i = 0; i < 4; i++) {
    if (current == null || current === "") return [];

    if (Array.isArray(current)) {
      return current.map((x) => String(x).trim()).filter(Boolean);
    }

    if (typeof current === "object") {
      return [];
    }

    if (typeof current === "string") {
      const trimmed = current.trim();
      if (!trimmed) return [];
      try {
        current = JSON.parse(trimmed);
        continue;
      } catch {
        return trimmed
          .replace(/^\[/, "")
          .replace(/\]$/, "")
          .split(",")
          .map((x) => x.trim().replace(/^['"]|['"]$/g, ""))
          .filter(Boolean);
      }
    }

    return [];
  }

  return [];
}

export function getTaskByInventoryTag(tags: string[], inventoryId: string): string | null {
  const needle = `task_by_${inventoryId}`;
  return tags.find((t) => t === needle || t.trim() === needle) ?? null;
}

export function hasTaskByInventoryTag(tags: string[], inventoryId: string): boolean {
  return getTaskByInventoryTag(tags, inventoryId) != null;
}

/** Spolehlivá detekce tagu i při dvojitém JSON kódování AWSJSON. */
export function hasTaskByInventoryTagRaw(raw: unknown, inventoryId: string): boolean {
  const needle = `task_by_${inventoryId}`;
  if (typeof raw === "string" && raw.includes(needle)) return true;
  return hasTaskByInventoryTag(parsePlaceTags(raw), inventoryId);
}

export function getInventoryIdsRequiringTask(inventoryList: Array<{ place_tags?: unknown }>): Set<string> {
  const ids = new Set<string>();
  for (const item of inventoryList) {
    const tags = parsePlaceTags(item.place_tags);
    for (const tag of tags) {
      const match = String(tag).trim().match(/^task_by_(.+)$/i);
      if (match?.[1]) ids.add(match[1].trim());
    }
    if (typeof item.place_tags === "string") {
      const re = /task_by_[a-f0-9-]+/gi;
      let m: RegExpExecArray | null;
      while ((m = re.exec(item.place_tags)) !== null) {
        ids.add(m[0].replace(/^task_by_/i, ""));
      }
    }
  }
  return ids;
}

/** Místo má alespoň jeden tag task_by_* → task po odeslání libovolného inventáře na místě. */
export function hasAnyPlaceTaskTag(inventoryList: Array<{ place_tags?: unknown }>): boolean {
  return getInventoryIdsRequiringTask(inventoryList).size > 0;
}
